import { render } from "./FiltersComponent.vue?vue&type=template&id=34ac5604&scoped=true&ts=true"
import script from "./FiltersComponent.vue?vue&type=script&lang=ts"
export * from "./FiltersComponent.vue?vue&type=script&lang=ts"

import "./FiltersComponent.vue?vue&type=style&index=0&id=34ac5604&lang=css&scoped=true"

import exportComponent from "C:\\Users\\Ronnald\\Desktop\\page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ac5604"]])

export default __exports__